import { memo } from 'react';
import PropTypes from 'prop-types';
import { formatNumber, persianNumber } from 'helpers/utils/number';

function PersianNumber({ format, value }) {
  return persianNumber(format ? formatNumber(value) : value);
}

PersianNumber.propTypes = {
  format: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default memo(PersianNumber);
